import { BlogFulfillmentList } from 'components/Pages/BlogArticle/BlogFulfillmentList/BlogFulfillmentList';
import { useBlogPaymentsQueryApi } from 'graphql/generated';

export const BlogPaymentsList: FC = () => {
    const [{ data }] = useBlogPaymentsQueryApi();

    return <BlogFulfillmentList freeFulfillmentLimit={data?.freeFulfillmentLimit} fulfillmentItems={data?.payments} />;
};
